module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/point_maedori_01-bd8dfa1113860d6add388ebd0d1e8593.webp";